// extracted by mini-css-extract-plugin
export default {"subnavHolder":"PortfolioNav_subnavHolder__YPgYX","active":"PortfolioNav_active__g++iz","inactive":"PortfolioNav_inactive__PI0iK"};